import type { BookmarkButtonProps } from './BookmarkButton';
import type { BookmarkableTypes } from '../../types';
import { useMemo } from 'react';
import { MixPanel } from '~/common';
import { useAddSavedContentMutation, useRemoveSavedContentMutation } from '../../api';
import { useSavedContentContext } from '../../context';
import { MIXPANEL_SAVED_CONTENT_ADD, MIXPANEL_SAVED_CONTENT_REMOVE } from '../../constants';
import { BookmarkButton } from './BookmarkButton';

export interface BookmarkButtonContainerProps extends Omit<BookmarkButtonProps, 'isBookmarked' | 'onAdd' | 'onRemove'> {
  buttonType?: 'icon' | 'button';
  contentId: string;
  contentType: BookmarkableTypes;
  removeLabel?: string;
  addLabel?: string;
}

export function BookmarkButtonContainer({
  contentId,
  contentType,
  buttonType = 'icon',
  ...buttonProps
}: BookmarkButtonContainerProps) {
  const addMutation = useAddSavedContentMutation();
  const removeMutation = useRemoveSavedContentMutation();

  const { savedContentIds, isLoading } = useSavedContentContext();

  const isBookmarked = useMemo(() => savedContentIds.includes(contentId), [savedContentIds, contentId]);

  const handleAdd = () => {
    addMutation.mutate({ id: contentId, type: contentType });
    MixPanel.track(MIXPANEL_SAVED_CONTENT_ADD, { contentId, contentType });
  };

  const handleRemove = () => {
    removeMutation.mutate({ id: contentId, type: contentType });
    MixPanel.track(MIXPANEL_SAVED_CONTENT_REMOVE, { contentId, contentType });
  };

  return (
    <BookmarkButton
      isLoading={isLoading}
      isBookmarked={isBookmarked}
      onAdd={handleAdd}
      onRemove={handleRemove}
      buttonType={buttonType}
      {...buttonProps}
    />
  );
}
